import { coarsenContextAxes, type LineSignalContextInput } from './lineLearningSignals'

export type LineClusterAxes = Pick<ReturnType<typeof coarsenContextAxes>, 'planType' | 'workspaceType' | 'attachmentDensity' | 'timelineSpan'>

/** Must remain byte-for-byte compatible with the scheduled aggregator cluster key. */
export const lineClusterKeyFromAxes = (axes: LineClusterAxes) =>
  `${axes.planType}|${axes.workspaceType}|${axes.attachmentDensity}|${axes.timelineSpan}`

export const lineClusterKeyFromContext = (context: LineSignalContextInput) => {
  const axes = coarsenContextAxes(context)
  return { clusterId: lineClusterKeyFromAxes(axes), axes: { planType: axes.planType, workspaceType: axes.workspaceType, attachmentDensity: axes.attachmentDensity, timelineSpan: axes.timelineSpan } }
}
